import crudAction from '../actions'

export default {
  name: 'crmTasks',
  namespace: 'crm/tasks',
  methods: [...crudAction]
}
